import React, { useLayoutEffect } from 'react';

const MAX_HEIGHT = 160; // about six lines, then it scrolls

// Multi-line comment box that grows with its text.
// Desktop: Enter sends, Shift+Enter adds a line break.
// Touch devices: Enter adds a line break (like a messaging app) and the send button submits.
const CommentTextarea = ({ inputRef, value, onChange, placeholder, className = '', ariaLabel, autoFocus, testId }) => {
  useLayoutEffect(() => {
    const el = inputRef?.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, MAX_HEIGHT)}px`;
  }, [value, inputRef]);

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter' || e.shiftKey || e.nativeEvent.isComposing) return;
    const isTouch = typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches;
    if (isTouch) return; // let Enter insert a line break
    e.preventDefault();
    e.currentTarget.form?.requestSubmit();
  };

  return (
    <textarea
      ref={inputRef}
      rows={1}
      autoFocus={autoFocus}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      aria-label={ariaLabel}
      className={`resize-none overflow-y-auto leading-snug ${className}`}
      data-testid={testId}
    />
  );
};

export default CommentTextarea;
